/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import BodyText from "components/atoms/BodyText";
import FormPadding from "components/atoms/Form/FormPadding";
import Table from "components/molecules/Table";
import moment from "moment";
import React from "react";
import { IchangeLog } from "../interface";

const styleTable = css`
	th {
		width: 100px !important;
	}
	td {
		text-align: center;
	}
`;

const AttendHolidayModal: React.FC<{
	changeLogData: IchangeLog[];
	selectChangelog: string;
	customStyle?: any;
}> = ({ changeLogData, selectChangelog, customStyle }) => {
	return (
		<React.Fragment>
			{changeLogData[Number(selectChangelog)]?.modifyStampAppData && (
				<FormPadding customStyle={customStyle}>
					<div css={styleTable}>
						<Table customStyle={css({ width: "auto", padding: "14px 10px" })}>
							<thead>
								<tr>
									<Table.HeaderCell>対象日付</Table.HeaderCell>
									<Table.HeaderCell>休暇</Table.HeaderCell>
									<Table.HeaderCell>休暇単位</Table.HeaderCell>
									<Table.HeaderCell>開始時間</Table.HeaderCell>
									<Table.HeaderCell>終了時間</Table.HeaderCell>
									<Table.HeaderCell>取得時間</Table.HeaderCell>
								</tr>
							</thead>
							<tbody>
								{changeLogData && changeLogData[Number(selectChangelog)].modifyStampAppData?.length! > 0 ? (
									changeLogData[Number(selectChangelog)].modifyStampAppData?.slice(-1).map((ver: any, i: any) => (
										<tr key={ver.achievementId}>
											<Table.Cell>
												<BodyText>{ver.targetDate ? moment(ver.targetDate).format("YYYY/MM/DD") : "-"}</BodyText>
											</Table.Cell>
											<Table.Cell>
												<BodyText>{ver.holidayName ? ver.holidayName : "-"}</BodyText>
											</Table.Cell>
											<Table.Cell>
												<BodyText>{ver.holidayDigestiveUnitName ? ver.holidayDigestiveUnitName : "-"}</BodyText>
											</Table.Cell>
											<Table.Cell>
												<BodyText>
													{ver.holidayStartHm ? moment(ver.holidayStartHm).format("YYYY/MM/DD HH:mm:ss") : "-"}
												</BodyText>
											</Table.Cell>
											<Table.Cell>
												<BodyText>
													{ver.holidayStartHm ? moment(ver.holidayEndHm).format("YYYY/MM/DD HH:mm:ss") : "-"}
												</BodyText>
											</Table.Cell>
											<Table.Cell>
												<BodyText>{ver.holidayTimes ? ver.holidayTimes : "-"}</BodyText>
											</Table.Cell>
										</tr>
									))
								) : (
									<tr>
										<Table.Cell>
											<BodyText>
												{changeLogData[Number(selectChangelog)].targetDate
													? changeLogData[Number(selectChangelog)].targetDate
													: "-"}
											</BodyText>
										</Table.Cell>
										<Table.Cell>
											<BodyText>-</BodyText>
										</Table.Cell>
										<Table.Cell>
											<BodyText>-</BodyText>
										</Table.Cell>
										<Table.Cell>
											<BodyText>-</BodyText>
										</Table.Cell>
										<Table.Cell>
											<BodyText>-</BodyText>
										</Table.Cell>
										<Table.Cell>
											<BodyText>-</BodyText>
										</Table.Cell>
									</tr>
								)}
							</tbody>
						</Table>
					</div>
				</FormPadding>
			)}
		</React.Fragment>
	);
};

export default AttendHolidayModal;
